






import ViewModel from '@/App.ts';
export default ViewModel;
